import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", {
  class: "row",
  style: {"height":"20px"}
}, [
  /*#__PURE__*/_createElementVNode("div", { class: "col" })
], -1)
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", {
  class: "row",
  style: {"height":"45px"}
}, [
  /*#__PURE__*/_createElementVNode("div", { class: "col" })
], -1)
const _hoisted_3 = {
  key: 0,
  class: "row",
  style: {"height":"45px"}
}
const _hoisted_4 = { class: "col" }
const _hoisted_5 = {
  key: 0,
  class: "col-1 no-padding"
}
const _hoisted_6 = { class: "PurpleToWhite" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", { class: "col" }, null, -1)
const _hoisted_8 = {
  key: 1,
  class: "col-1 no-padding"
}
const _hoisted_9 = { class: "text-white bg-secondary" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("div", { class: "col" }, null, -1)
const _hoisted_11 = {
  key: 2,
  class: "col-1 no-padding"
}
const _hoisted_12 = { class: "PurpleToWhite" }
const _hoisted_13 = {
  key: 0,
  class: "ellipsis"
}
const _hoisted_14 = {
  key: 1,
  class: "ellipsis"
}
const _hoisted_15 = { class: "text-h6" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_TabViewer = _resolveComponent("TabViewer")!
  const _component_q_btn = _resolveComponent("q-btn")!
  const _component_q_card_section = _resolveComponent("q-card-section")!
  const _component_q_card_actions = _resolveComponent("q-card-actions")!
  const _component_q_card = _resolveComponent("q-card")!
  const _component_q_dialog = _resolveComponent("q-dialog")!
  const _component_MainContent = _resolveComponent("MainContent")!
  const _directive_close_popup = _resolveDirective("close-popup")!

  return (_openBlock(), _createBlock(_component_MainContent, null, {
    default: _withCtx(() => [
      _createVNode(_component_TabViewer, {
        step: _ctx.currentPage,
        images: _ctx.wizardImages,
        changeTabWizard: _ctx.changePageWithWizard
      }, null, 8, ["step", "images", "changeTabWizard"]),
      _hoisted_1,
      (_openBlock(), _createBlock(_resolveDynamicComponent(_ctx.componentName), {
        changePage: _ctx.updatePage,
        changeTransport: _ctx.updateTransport,
        changePerfusionWay: _ctx.updatePerfusionWay,
        updateSelectedMeds: _ctx.updateSelectedMeds,
        transport: _ctx.transport,
        tabOfViewName: _ctx.tabOfViewName,
        currentPage: _ctx.currentPage,
        perfusionWay: _ctx.perfusionWay,
        tabOfSelectedMeds: _ctx.tabOfSelectedMeds
      }, null, 8, ["changePage", "changeTransport", "changePerfusionWay", "updateSelectedMeds", "transport", "tabOfViewName", "currentPage", "perfusionWay", "tabOfSelectedMeds"])),
      _hoisted_2,
      (!_ctx.hideElements)
        ? (_openBlock(), _createElementBlock("nav", _hoisted_3, [
            _createElementVNode("ul", _hoisted_4, [
              (_ctx.currentPage != 0)
                ? (_openBlock(), _createElementBlock("li", _hoisted_5, [
                    _createElementVNode("div", _hoisted_6, [
                      _createVNode(_component_q_btn, {
                        class: _normalizeClass({'KompatPrevButtonsResponsiveStyle' :_ctx.$q.screen.lt.sm&&_ctx.currentPage == 3}),
                        "no-caps": "",
                        flat: "",
                        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.prevPage())),
                        style: {"width":"100%"}
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString('< ' + _ctx.$t('PreviousButton')), 1)
                        ]),
                        _: 1
                      }, 8, ["class"])
                    ])
                  ]))
                : _createCommentVNode("", true),
              _hoisted_7,
              (_ctx.currentPage == 4)
                ? (_openBlock(), _createElementBlock("li", _hoisted_8, [
                    _createElementVNode("div", _hoisted_9, [
                      _createVNode(_component_q_btn, {
                        "no-caps": "",
                        flat: "",
                        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.printPage())),
                        style: {"width":"100%"}
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.$t('PrintButton')), 1)
                        ]),
                        _: 1
                      })
                    ])
                  ]))
                : _createCommentVNode("", true),
              _hoisted_10,
              (_ctx.currentPage == 0 || _ctx.currentPage == 3)
                ? (_openBlock(), _createElementBlock("li", _hoisted_11, [
                    _createElementVNode("div", _hoisted_12, [
                      _createVNode(_component_q_btn, {
                        class: _normalizeClass({'KompatNextButtonsResponsiveStyle':_ctx.$q.screen.lt.sm&&_ctx.currentPage == 3}),
                        "no-caps": "",
                        flat: "",
                        onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.nextPage())),
                        style: {"width":"100%"}
                      }, {
                        default: _withCtx(() => [
                          (_ctx.currentPage != 3)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_13, _toDisplayString(_ctx.$t('NextButton') + ' >'), 1))
                            : _createCommentVNode("", true),
                          (_ctx.currentPage == 3)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_14, _toDisplayString(_ctx.$t('Compatibility.ShowCompatibilitiesButton') + ' >'), 1))
                            : _createCommentVNode("", true)
                        ]),
                        _: 1
                      }, 8, ["class"])
                    ])
                  ]))
                : _createCommentVNode("", true)
            ])
          ]))
        : _createCommentVNode("", true),
      _createVNode(_component_q_dialog, {
        modelValue: _ctx.showNoneSelectedError,
        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.showNoneSelectedError) = $event))
      }, {
        default: _withCtx(() => [
          _createVNode(_component_q_card, null, {
            default: _withCtx(() => [
              _createVNode(_component_q_card_section, null, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_15, _toDisplayString(_ctx.$t('Error')), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_q_card_section, { class: "q-pt-none column" }, {
                default: _withCtx(() => [
                  _createElementVNode("div", null, _toDisplayString(_ctx.$t('Compatibility.NoneSelectedError')), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_q_card_actions, { align: "right" }, {
                default: _withCtx(() => [
                  _withDirectives(_createVNode(_component_q_btn, {
                    flat: "",
                    label: "OK",
                    color: "primary"
                  }, null, 512), [
                    [_directive_close_popup]
                  ])
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["modelValue"])
    ]),
    _: 1
  }))
}